module.exports = __webpack_public_path__ + "static/media/sort-shapes-up-alt.51b8c6bb.svg";